import { render, staticRenderFns } from "./memberDetail.vue?vue&type=template&id=a9d56df2&scoped=true"
import script from "./memberDetail.vue?vue&type=script&lang=js"
export * from "./memberDetail.vue?vue&type=script&lang=js"
import style0 from "./memberDetail.vue?vue&type=style&index=0&id=a9d56df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d56df2",
  null
  
)

export default component.exports